"use client"
import React from 'react'
import useFetch from '@/app/useFetch'
import Link from 'next/link';
import { IMG_URL } from '@/app/config';

const NewsDetails = ({permalink}) => {
  
    //  const [page, setPage] = useState(1);
      const { data: list, loading, error } = useFetch(
          `/website/homepage-news-and-events-details/${permalink}`,
          // { page, limit: 5 }, // pass page & limit here
          []
      );
  
  return (
   <>
   <div className="details-section mt-40">
  <img src={`${IMG_URL}${list.photo}`} alt="Police Station Award" className="vigilance-img" />

  <h2>{list.name}</h2>
  <p>{list?.description}</p>
</div>

   </>
  )
}

export default NewsDetails
